export const faqs = [
  {
    id: 'faq-1',
    question: '一级免费网站是什么？所有资源真的免费吗？',
    answer: '一级免费网站是一个精心筛选的免费网络资源导航平台，我们收录的每一个资源都经过人工审核确认，在基础功能层面确实是完全免费的。部分资源可能提供付费高级版本，但其基础免费版已足够满足大多数用户的需求。我们坚持只收录真正有免费价值的优质资源，让您无需注册、无需付费就能直接使用。',
  },
  {
    id: 'faq-2',
    question: '网站上的资源需要注册才能使用吗？',
    answer: '绝大多数收录的免费资源可以直接使用，不需要注册账号。部分在线工具和平台可能需要简单注册以保存您的使用记录和设置，但注册本身是完全免费的，且我们优先推荐无需注册即可使用的资源。我们的导航平台本身完全不需要注册，即开即用。',
  },
  {
    id: 'faq-3',
    question: '收录的资源安全吗？会不会有病毒或恶意软件？',
    answer: '安全性是我们最重视的方面之一。我们收录的所有资源都经过安全审核，优先推荐知名品牌和开源社区的产品。对于下载类资源，我们建议用户从官方网站下载，避免使用第三方下载站。如果您发现任何资源存在安全隐患，欢迎通过联系表单向我们反馈，我们会立即核实处理。',
  },
  {
    id: 'faq-4',
    question: '如何提交新的免费资源推荐？',
    answer: '我们非常欢迎您推荐优质的免费资源！您可以通过"关于我们"页面中的联系表单提交资源推荐信息，包括资源名称、网址和简要描述。我们的编辑团队会在24小时内审核，审核通过后会将符合条件的优质资源添加到相应分类中，并标注推荐者信息。',
  },
  {
    id: 'faq-5',
    question: '网站多久更新一次资源内容？',
    answer: '我们的编辑团队每天都会关注最新的免费资源动态，每周至少进行一次资源更新和维护。新发现的优质资源会优先添加到"最新资源"板块，过期或失效的链接也会及时清理和替换。您可以收藏本站并定期访问，获取最新的免费资源信息。',
  },
  {
    id: 'faq-6',
    question: '免费资源的商用限制是怎样的？',
    answer: '不同资源的商用授权各不相同。一般来说，开源资源（如开源字体、开源图标等）大都支持免费商用。但我们建议在使用任何资源进行商业用途前，仔细阅读该资源的授权协议。我们的文章栏目中也有专门的"免费商用指南"系列，帮助您了解各类资源的授权规则。',
  },
  {
    id: 'faq-7',
    question: '网站上的资源分类如何浏览？',
    answer: '我们提供两种浏览方式：一是通过首页的分类卡片直接进入感兴趣的资源分类；二是通过顶部导航栏的"全部分类"查看完整的分类列表。每个分类页面都会展示该类别下的所有资源，您可以按热度、最新等维度进行筛选查看。',
  },
  {
    id: 'faq-8',
    question: '一级免费网站与其他导航网站有什么不同？',
    answer: '与一般的导航网站相比，一级免费网站有三大特色：第一，我们坚持只收录"真正免费"的优质资源，不会混入大量付费广告链接；第二，每个资源都附有详细的介绍和使用建议，帮助您快速判断是否适合自己；第三，我们持续产出高质量的原创免费资源使用指南文章，不仅告诉您"有什么"，还告诉您"怎么用"。',
  },
];